import React from "react"

import { ProjectHistoryFilterState } from "widgets/project-history/project-history-filter/ProjectHistoryFilter"

import { ProjectHistoryModel } from "./model/useProjectHistoryModel"
import { useProjectHistoryViewModel } from "./model/useProjectHistoryViewModel"
import { ProjectHistoryView } from "./ui/ProjectHistoryView"

export interface ProjectHistoryProps extends ProjectHistoryModel {
  filterValues: ProjectHistoryFilterState
}

export const ProjectHistory = React.memo(
  ({ filterValues, ...model }: ProjectHistoryProps) => (
    <ProjectHistoryView {...useProjectHistoryViewModel(model, filterValues)} />
  )
)
